.container{
    padding-top: 10px;
}

.requirements {
    display: flex;
    padding: 10px 0px;
    justify-content: space-around;
}

.requirementsMet {
    width: 33%;
    max-width: 250px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.assessmentNumber {
    text-align: center;
    letter-spacing: 0.1px;
    color: var(--hps-white);
    text-transform: uppercase;
    font-size: 40px;
    font-family: var(--hps-primary-font);
    font-weight: bolder;
}

.requirementsMetBreakdown {
    padding-top: 5px;
}

.requirementBreakdown {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 50%;
}

.requirementGroups {
    display: flex;
    justify-content: space-around;
}

.group {
    width: 15%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto 0px 0px;
}